<template>
  <a-form
    ref="formRef"
    layout="vertical"
    :model="form"
    class="form"
  >
    <a-form-item
      v-for="i in 4"
      :key="i"
      :label="$t(`weekly.quarters.${i-1}`)"
      :name="[i-1]"
      :rules="{
        type: 'string',
      }"
    >
      <a-textarea
        v-model:value="form[i-1]"
        :placeholder="$t('weekly.placeholder')"
        :auto-size="{ minRows: 6, maxRows: 6 }"
      />
    </a-form-item>
  </a-form>
  <FormAction
    :loading="loading"
    :can-close="canClose"
    @cancel="emit('cancel')"
    @save="onSave()"
  />
</template>
<script setup>
import { ref, defineEmits, unref, watch } from 'vue'
import FormAction from '@/views/OkrList/FormAction.vue'
import { updateObjective } from '@/api/okr'
import { message } from 'ant-design-vue'
import { useI18n } from 'vue-i18n'
const emit = defineEmits(['cancel', 'update:objectiveDesc', 'update:canClose'])
const props = defineProps({
  objectiveDesc: {
    type: String,
    default: '[]'
  },
  objectiveId: {
    type: Number,
    default: undefined
  },
  updateObjectiveDescription: {
    type: Function,
    default: () => {}
  },
  canClose: {
    type: Boolean,
    required: true
  }
})
const { t } = useI18n()
const form = unref(ref(JSON.parse(props.objectiveDesc)))
const formRef = ref()

const loading = ref(false)
const onSave = async () => {
  const params = {
    output_desc: JSON.stringify(form)
  }
  loading.value = true
  try {
    await formRef.value.validate()
  } catch (_) {
    loading.value = false
    return
  }
  updateObjective(props.objectiveId, params).then(res => {
    loading.value = false
    if (res) {
      message.success(t('weekly.editSuccess'))
      props.updateObjectiveDescription(JSON.stringify(form))
      // emit('update:objectiveDesc', JSON.stringify(form))
      emit('update:canClose', false)
      emit('cancel')
    } else {
      message.error(t('weekly.editError'))
    }
  })
}

watch(form, () => {
  emit('update:canClose', false)
})

</script>
